import type { RoundingRule } from '@gpa-scales/shared-types';

export function formatGPA(value: number, rounding?: RoundingRule): string {
  if (rounding && rounding.mode !== 'none') {
    const places = rounding.mode === 'decimal_1' ? 1 : rounding.mode === 'decimal_2' ? 2 : 3;
    return value.toFixed(places);
  }
  return value.toFixed(4).replace(/0+$/, '').replace(/\.$/, '');
}

export function formatPercentage(value: number): string {
  return `${value.toFixed(1)}%`;
}

export function formatCredits(value: number): string {
  return value % 1 === 0 ? value.toString() : value.toFixed(1);
}
